import React, { Component } from 'react';
import AbacusSelect from '../Components/AbacusSelect';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AbacusTextField from '../Components/AbacusTextField';
import AbacusTextFieldBox from '../Components/AbacusTextFieldBox';
import { CloudStatus, CloudStatusIconColor } from '../Enums/ClodStatusEnum';
import StatusService from "../Services/ClousStatusService";
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import Info from '@material-ui/icons/Info';


class OTCloudStatusView extends Component {
    currentState = {
        statusType: CloudStatus.NoIssue,
        reason: ""
    };

    statusTypes = [
        { value: CloudStatus.NoIssue, text: "No issues to report" },
        { value: CloudStatus.FirstReportOfIssue, text: "First report of issue" },
        { value: CloudStatus.UnknownIssue, text: "Unknown Issue" },
        { value: CloudStatus.DnsError, text: "DNS Error" },
        { value: CloudStatus.IntermediaIssue, text: "Intermedia Issue" },
        { value: CloudStatus.OperationalButNotFully, text: "Operational but not full capacity" },
        { value: CloudStatus.IterationUpdate, text: "Iteration Update" },
        { value: CloudStatus.SilentUpdate, text: "Silent Update" },
        { value: CloudStatus.Custom, text: "Custom" },
    ];

    iconSelection = [
        { value: CloudStatusIconColor.Green, text: "Fully Operational", icon: <CheckCircle className="md-green"></CheckCircle> },
        { value: CloudStatusIconColor.Red, text: "Alert", icon: <Error className="md-red"></Error> },
        { value: CloudStatusIconColor.Orange, text: "Caution", icon: <RemoveCircle className="md-orange"></RemoveCircle> },
        { value: CloudStatusIconColor.Blue, text: "Information", icon: <Info className="md-blue"></Info> },
    ];
    // Constructor initiate callback methods and sets initial state
    constructor(props) {
        super(props);

        this.data = props.data;
        // Set state
        this.state = { ...this.currentState }
    }

    // callback for showing Progress circle.
    showProgress(show) {
        this.setState({
            showProgress: show
        });
    }
    // Drop Down Change Events
    dropDownChange(controlName, event) {
        if (controlName === "Status") {
            this.currentState.statusType = event.target.value;
            this.props.getSelection(this.currentState.statusType);
        }
        else if (controlName === "Icon") {
            this.currentState.iconType = event.target.value;
        }
        this.setControlsState();

        this.clear();
    }

    // Text Field Change Events
    textFieldChange(control, event) {
        this.currentState.IsValid = true;
        if (control === "Reason") {
            this.currentState.reason = event.target.value;
        }
        if (control === "Description") {
            this.currentState.description = event.target.value;
        }
        if (control === "Header") {
            this.currentState.header = event.target.value;
        }
        this.setControlsState();
    }
    clear() {
        this.currentState.reason = "";
        this.currentState.description = "";
        this.currentState.header = "";
        this.setControlsState();
    }
    setControlsState() {

        // Final set state
        this.setState({ ...this.currentState });
    }
    buttonStyle = {
        width: "130px",
        marginTop: "12px"
    }

    boxStyle = {
        height: "150px",
        textAlign: "start"
    }

    async submit() {
        try {
            let service = new StatusService(this.data);

            var result = await service.createOTStatus({
                reason: this.currentState.reason,
                statusType: this.currentState.statusType,
                header: this.currentState.header,
                description: this.currentState.description,
                icon: this.currentState.iconType
            })
            this.clear();
            console.log(result);
        }
        catch (error) {
            console.log(error);
            this.data.Service.ErrorCallback(error.message);
        }
    }

    customRender() {
        return (<div>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <div style={{ height: "30px" }}></div>
                </Grid>
                <Grid item xs={4}>
                    <AbacusSelect error={false} style={{ width: "300px" }} value={this.state.statusType} list={this.statusTypes} label="Status" onChange={this.dropDownChange.bind(this, "Status")}></AbacusSelect>
                </Grid>
                <Grid item xs={12}>

                </Grid>
                <Grid item xs={8}>
                    <AbacusTextField value={this.state.reason} style={{ marginTop: "0px", width: "640px" }} Name="Reason" helperText="" onChange={this.textFieldChange.bind(this, "Reason")}></AbacusTextField>
                </Grid>
                <Grid item xs={12}>

                </Grid>
                <Grid item xs={4}>
                    <AbacusSelect error={false} style={{ width: "300px" }} value={this.state.iconType === undefined ? 1 : this.state.iconType} list={this.iconSelection} label="Icon" onChange={this.dropDownChange.bind(this, "Icon")}></AbacusSelect>
                </Grid>
                <Grid item xs={2}></Grid>

                <Grid item xs={8}>
                    <AbacusTextFieldBox value={this.state.header} style={{ marginTop: "0px", width: "640px" }} Name="Header" onChange={this.textFieldChange.bind(this, "Header")}></AbacusTextFieldBox>
                </Grid>

                <Grid item xs={8}>
                    <AbacusTextFieldBox value={this.state.description} style={{ marginTop: "0px", width: "640px" }} Name="Description" inputClass={this.boxStyle} onChange={this.textFieldChange.bind(this, "Description")}></AbacusTextFieldBox>
                </Grid>
                <Grid item xs={8}></Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}>
                    <Button style={this.buttonStyle} variant="contained" color="primary" disabled={this.state.reason === "" || this.state.description === ""} onClick={() => this.submit()}>
                        SUBMIT
                    </Button>
                </Grid>
            </Grid>
        </div>);
    }



    render() {
        if (this.state.statusType === CloudStatus.Custom) return this.customRender(); else {
            return (
                <div>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <div style={{ height: "30px" }}></div>
                        </Grid>
                        <Grid item xs={4}>
                            <AbacusSelect error={false} style={{ width: "300px" }} value={this.state.statusType} list={this.statusTypes} label="Status" onChange={this.dropDownChange.bind(this, "Status")}></AbacusSelect>
                        </Grid>
                        <Grid item xs={12}>

                        </Grid>
                        <Grid item xs={8}>
                            <AbacusTextField value={this.state.reason} style={{ marginTop: "0px", width: "640px" }} Name="Reason" helperText="" onChange={this.textFieldChange.bind(this, "Reason")}></AbacusTextField>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}>
                            <Button style={this.buttonStyle} variant="contained" color="primary" disabled={this.state.reason === ""} onClick={() => this.submit()}>
                                SUBMIT
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            );
        }
    }

}

export default OTCloudStatusView;